<template>
  <div class='waf-loading-spinner'>
    <lottie-animation
      ref="anim"
      :animationData="require('@/assets/icons/animations/waf-data-loader.json')"
      :loop="true"
    />
  </div>
</template>

<script>
import LottieAnimation from 'lottie-web-vue';

export default {
  name: 'WafLoadingSpinner',
  components: {
    LottieAnimation,
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.waf-loading-spinner {
  position: relative;
  left: $space-2;
  top: $space-10;
  width: rem(38);
}
</style>
